import { render } from "./FilmCheckbox.vue?vue&type=template&id=0aaa1620&scoped=true"
import script from "./FilmCheckbox.vue?vue&type=script&lang=js"
export * from "./FilmCheckbox.vue?vue&type=script&lang=js"

import "./FilmCheckbox.vue?vue&type=style&index=0&id=0aaa1620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaa1620"]])

export default __exports__